import { render, staticRenderFns } from "./EditorHeaderPresentButton.vue?vue&type=template&id=e4274150&scoped=true"
import script from "./EditorHeaderPresentButton.vue?vue&type=script&lang=js"
export * from "./EditorHeaderPresentButton.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderPresentButton.vue?vue&type=style&index=0&id=e4274150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4274150",
  null
  
)

export default component.exports